import styled from "styled-components";

export const ContainerEditarListas = styled.div`
  .editar {
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }

  .toggle-situacao {
    display: flex;
    align-items: center;
  }

  >.descricao-categoria{
    margin-bottom: 24px;
    text-align: start;
  }
  >.mais {
    margin-bottom: 16px;
    background-color: ${(props) => props.theme.colors.elements};
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    gap: 8px;
    position: relative;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    border-radius: 32px;
    width: fit-content;
    height: 33px;
    cursor: pointer;
    padding: 8px 16px;
    @media (max-width: 768px) {
      height: 30px;
    }

    >.plus {
      width: 18px;
      fill: ${(props) => props.theme.colors.primary};

      @media (max-width: 768px) {
        width: 14px;
      }
    }
  }
  .tabela-listagem-categorias{
    >.scrollBonitoBottom, >.tableContainer, table, tbody, tr{
      background-color: ${(props) => props.theme.colors.background2} !important;

      >td{
        padding: 4px !important;
      }
    }
    >.scrollBonitoBottom, >.tableContainer, table, thead, tr, th{
      padding: 4px !important;

      >.th-wrapper{
        padding: 0px !important;
      }
    }
  }
`;

export const ModalReativar = styled.div`
  padding: 3rem;
  .texto{
    margin-top: 2rem;
    margin-bottom: 5rem;
  }
  .reativar{
    margin-bottom: 3rem;
    display: flex;
    justify-content: center;
    input {
      accent-color: ${(props) => props.theme.colors.primary};
    }
    span{
      margin-left: 1rem;
    }
  }
`;

export const Botoes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .cancelar {
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      fill: ${(props) => props.theme.colors.primary};
      transform: rotate(90deg);
    }
  }
`;

export const CriarCategoriaContainer = styled.div`
  &.hidden {
    display: none;
  }

  >.descricao-categoria{
    margin-bottom: 24px;
    text-align: start;
  }

  .botoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6rem;

    .cancelar {
      color: ${(props) => props.theme.colors.tertiary};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      svg {
        fill: ${(props) => props.theme.colors.tertiary};
        transform: rotate(90deg);
      }
    }
  }

  .inputs {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center; 
    @media (max-width: 385px) {
      gap: 1rem;
    }

    >.input{
      width: 100%;
    }
  }
`;